import { render, staticRenderFns } from "./Dragable.vue?vue&type=template&id=2f522cb2&scoped=true&"
import script from "./Dragable.vue?vue&type=script&lang=js&"
export * from "./Dragable.vue?vue&type=script&lang=js&"
import style0 from "./Dragable.vue?vue&type=style&index=0&id=2f522cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f522cb2",
  null
  
)

export default component.exports